import { Icon } from "@pepperstone/pepper-ui-kit";

import { Typo } from "../Typo";

type FieldErrorV2Props = {
  text: string;
};

export const FieldErrorV2 = ({ text }: FieldErrorV2Props) => (
  <div className="flex items-center gap-2 text-text-base-failed">
    <Icon icon="alert-triangle" size={14} />
    <Typo element="span" type="bodySM" textColor="text-text-base-failed">
      {text}
    </Typo>
  </div>
);
